export default __webpack_public_path__ + "static/media/renew.554ac8fe.png";